"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var defaultState = {
  hasUserLegalAge: false
};
var _default = defaultState;
exports.default = _default;